import React from 'react';
import { Link } from 'react-router-dom';
import { PAGE_URLS } from '@constants';

export const OneLoginInvalid = () => {
    return (
        <h2>
            <center>
                Please <Link to={PAGE_URLS.AUTHORIZE}>login</Link> with your Azure SSO credentials. If that doesn&apos;t work, contact help@stratfs.com.
            </center>
        </h2>
    );
};

export default OneLoginInvalid;
